import { render, staticRenderFns } from "./DigitacionRegistra.vue?vue&type=template&id=d7ddda2e&"
import script from "./DigitacionRegistra.vue?vue&type=script&lang=js&"
export * from "./DigitacionRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports